<button type="button" class="add-item-btn d-flex align-items-center justify-content-center">
  <svg viewBox="0 0 15 14"><use href="#plus-white" /></svg>
</button>
